
import React from 'react';
import VisaRecommendations from '@/components/VisaRecommendations';
import { SEO } from '@/components/SEO';
import { ResponsiveContainer } from '@/components/ui/responsive-wrapper';
import { useIsMobile } from '@/hooks/use-mobile';
import { BreadcrumbNav } from '@/components/navigation/BreadcrumbNav';

const VisaRequirementsPage = () => {
  const isMobile = useIsMobile();
  
  // Define breadcrumbs for visa requirements page
  const breadcrumbs = [
    { name: 'Home', url: '/' },
    { name: 'Visa Requirements', url: '/visa-requirements', isCurrentPage: true }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO 
        title="Visa Requirements" 
        description="Find visa requirements for countries around the world based on your nationality."
        keywords={['visa requirements', 'travel documents', 'international travel', 'passport requirements']}
        breadcrumbs={breadcrumbs}
      />
      <ResponsiveContainer className="py-8 md:py-12">
        <BreadcrumbNav items={breadcrumbs} />
        <h1 className={`font-bold ${isMobile ? 'text-2xl mb-3' : 'text-3xl mb-4'}`}>
          Visa Requirements
        </h1>
        <p className="text-gray-600 mb-6 md:mb-8">
          Find visa requirements for countries around the world based on your nationality
        </p>
        <VisaRecommendations />
      </ResponsiveContainer>
    </div>
  );
};

export default VisaRequirementsPage;
